/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import { useClickOutside, useHideBodyOverflow, useKeydown } from '@btime/react-hooks'
import React from 'react'

import { SmallText, Title } from '../presentation/Text'
import FlexGrid, { FlexColumn } from './FlexGrid'
import Icon from '../shapes/Icon'
import SeparatorWrapper from '../helpers/SeparatorWrapper'

const SideModalPanel = ({ children, footer, usePadding, onClose, ...props }) => {
  const wrapperRef = React.useRef()
  useClickOutside(wrapperRef, { action: onClose, condition: !!onClose })
  useKeydown(wrapperRef, { keys: !!onClose ? ['Escape'] : [], action: onClose })
  useHideBodyOverflow()

  const style = css`
    width: 28rem;
    max-width: 100%;
    max-height: 100%;
    background: white;
    box-shadow: ${COLORS.lightShadow1};
    display: flex;
    flex-direction: column;

    & > .body {
      flex: 1;
      padding: ${usePadding ? '1rem' : ''};
      overflow-y: scroll;
    }

    & > .footer {
      position: initial;
      background: white;
      box-shadow: ${COLORS.lightShadow1};
      padding: 1rem;
    }
  `

  return (
    <div css={style} ref={wrapperRef}>
      <div className="body">
        <div className="contentWrap">{children}</div>
      </div>
      {footer && <div className="footer">{footer}</div>}
    </div>
  )
}

export const SideModalHeader = ({ noPadding, title, subtitle, onClose, leftContent, rightContent, useReturn }) => {
  if (!rightContent && !useReturn)
    rightContent = <Icon onClick={onClose} name="BsX" color={COLORS.purple} size="2rem" />
  if (!leftContent && !!useReturn)
    leftContent = <Icon onClick={onClose} name="BsArrowLeftShort" color={COLORS.purple} size="2rem" />
  return (
    <SeparatorWrapper weight={noPadding ? 0 : 4}>
      <FlexGrid justify="space-between">
        <FlexColumn flex={1}>{leftContent}</FlexColumn>
        <FlexColumn flex={2}>
          <SmallText size="xsmall" color={COLORS.dark3} align="center">
            {subtitle}
          </SmallText>
          <Title size="h5" color={COLORS.dark2} noMargin align="center">
            {title}
          </Title>
        </FlexColumn>
        <FlexColumn flex={1}>
          <FlexGrid justify="flex-end">{rightContent}</FlexGrid>
        </FlexColumn>
      </FlexGrid>
    </SeparatorWrapper>
  )
}

const SideModalWrapper = ({ open, onClose, children, ...props }) => {
  const style = css`
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 100;
    background-color: #00000070;
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  `

  return <div css={style}>{children}</div>
}

const SideModal = ({ open, onClose, children, ...props }) => {
  if (!open) return false

  return (
    <SideModalWrapper>
      <SideModalPanel onClose={onClose} {...props}>
        {children}
      </SideModalPanel>
    </SideModalWrapper>
  )
}

export default SideModal
